"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = void 0;
const path_1 = __importDefault(require("path"));
const fs_1 = __importDefault(require("fs"));
const yaml_1 = require("yaml");
const vec3_1 = require("vec3");
const existsViaStats = async (path) => {
    try {
        await fs_1.default.promises.stat(path);
        return true;
    }
    catch (e) {
        return false;
    }
};
const loadWarps = async (warpsFolder, serv) => {
    if (await existsViaStats(warpsFolder)) {
        fs_1.default.promises.readdir(warpsFolder).then(async (files) => {
            const warps = [];
            for (const file of files) {
                if (!file.endsWith('.yml'))
                    continue;
                const contents = await fs_1.default.promises.readFile(path_1.default.join(warpsFolder, file), 'utf8');
                const parsed = (0, yaml_1.parse)(contents);
                warps.push(parsed);
            }
            serv.warps = warps;
            serv.emit('warpsLoaded');
        });
    }
};
const server = async function (serv, options) {
    serv.warps = [];
    const { worldFolder } = options;
    let warpsFolder = '';
    if (worldFolder) {
        warpsFolder = path_1.default.join(worldFolder, 'Warp files');
        loadWarps(warpsFolder, serv);
    }
    serv.commands.add({
        base: 'warp',
        info: 'Teleport to a warp',
        usage: '/warp [set] <name>',
        op: true,
        tab: ['warps', 'warps'],
        commandBlock: false,
        parse(string, ctx) {
            // todo worlds support
            if (string.startsWith('set ')) {
                const name = string.slice(4);
                return { name, set: true };
            }
            const warp = serv.warps.find(w => w.name === string);
            if (!warp)
                return false;
            return { name: warp.name };
        },
        async action({ name, set }, { player }) {
            if (!warpsFolder || !player)
                return;
            if (set) {
                // write to fs, ensure dir
                if (!await existsViaStats(warpsFolder)) {
                    await fs_1.default.promises.mkdir(warpsFolder);
                    await fs_1.default.promises.writeFile(path_1.default.join(warpsFolder, `${name}.yml`), `name: ${name}\nworld: ${'world'}\nx: ${player.position.x}\ny: ${player.position.y}\nz: ${player.position.z}\nyaw: ${player.yaw}\npitch: ${player.pitch}\nlastowner: ${player.uuid}`);
                }
                return;
            }
            const warp = serv.warps.find(w => w.name === name);
            if (!warp)
                return;
            player.teleport(new vec3_1.Vec3(warp.x, warp.y, warp.z));
            if (warp.yaw)
                player.yaw = warp.yaw;
            if (warp.pitch)
                player.pitch = warp.pitch;
            player.chat(`Teleported to ${name}. Press f3+a if nothing appears on your screen.`);
        }
    });
    serv.commands.add({
        base: 'home',
        info: 'Teleport to your home',
        usage: '/home',
        op: false, // todo
        commandBlock: false,
        async action({}, { player }) {
            player?.handleCommand('warp home');
        }
    });
    serv.commands.add({
        base: 'sethome',
        info: 'Set your home',
        usage: '/sethome',
        op: false, // todo
        commandBlock: false,
        async action({}, { player }) {
            player?.handleCommand('warp set home');
        }
    });
};
exports.server = server;
/*
warp yml:
world: world
x: -186.3640491750058
y: 69.0
z: -1181.5200906606556
yaw: 270.91583
pitch: -3.3620992
name: AshfieldCentral
lastowner: 0d33e85d-575d-4247-9f17-f44114d6a426
*/
